<template>
    <div>
      <patent-annuity-status-list></patent-annuity-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  